import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class SnapshotPresenter extends EntityPresenter {
  static urn = 'snapshots'

  static navOptions(key = 'snapshots') {
    const routes = {
      snapshots: {
        pageRoutes: ['snapshots'],
      }
    }
    return routes[key]
  }
}

bindPresenterMethods(SnapshotPresenter)
